import {baseDataService} from "@/services/baseData.service";

export const state = {
    salesArea:[] 
}

export const actions = {
    // Logs in the user.
    // eslint-disable-next-line no-unused-vars
    async getSalesReps({state,commit}){
        try { 
            if(state.salesArea && state.salesArea.length==0){
                let prod = await baseDataService.listSalesAreas(); 
                commit('setSalesArea', prod);
                return prod;
            }
            return state.salesArea;
        } catch (error) {
            console.error("List categories",error);
            commit('loadSalesArea');
            
        }
        return state.salesArea
    },
}
export const mutations = {
    setSalesArea(state, salesArea) {
        state.salesArea = salesArea; 
        localStorage.setItem("salesArea",JSON.stringify(salesArea)); 
    },
    loadSalesArea(state) {
        let salesArea = JSON.parse(localStorage.getItem("salesArea"));
        if(salesArea){
            state.salesArea = salesArea; 
        }
    },
}